/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
  DeleteApiV1LocationCountriesCountryidLangsIdPathParams,
  DeleteApiV1LocationCountriesCountryidLangsId401,
  DeleteApiV1LocationCountriesCountryidLangsId404,
  DeleteApiV1LocationCountriesCountryidLangsId500,
} from "../../types/locationCountryLangController/DeleteApiV1LocationCountriesCountryidLangsId.ts";

function getDeleteApiV1LocationCountriesCountryidLangsIdUrl(
  countryId: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["countryId"],
  id: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/location/countries/${countryId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Remove permanentemente uma tradução (idioma) de país. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs/:id}
 */
export async function deleteApiV1LocationCountriesCountryidLangsId(
  countryId: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["countryId"],
  id: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesCountryidLangsId401
      | DeleteApiV1LocationCountriesCountryidLangsId404
      | DeleteApiV1LocationCountriesCountryidLangsId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1LocationCountriesCountryidLangsIdUrl(
      countryId,
      id,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
